'use strict';
import angular from 'angular';
import './scripts/vendors.ctrls';
import './scripts/vendors.services';

import vendorRegisterHtmlUrl from './views/vendorRegister.html';

angular.module('vendors', [
    'vendors.ctrls',
    'vendors.services'
])

    .config(['$stateProvider', function($stateProvider) {
        $stateProvider
            .state('vendorRegistration', {
                parent: 'loginlayout',
                url: '/register',
                templateUrl: vendorRegisterHtmlUrl,
                controller: 'vendorRegistrationController'
            })
    }]);